import React from 'react';
import { Icon, theme } from '../../../ui';

const AnswerStatusIcon = ({ grade }) => {
  const CorrectResponse = Icon['Valid'];
  const IncorrectResponse = Icon['Wrong'];
  const UnreadResponse = Icon['AnswerUnread'];

  return (
    <>
      {grade === 1 ? (
        <CorrectResponse size='small' color={theme.colors.SUCCESS_GREEN} />
      ) : grade === 0 ? (
        <IncorrectResponse size='small' color={theme.colors.ERROR_RED} />
      ) : (
        <UnreadResponse size='small' color={theme.colors.NEU_PRIMARY} />
      )}
    </>
  );
};

export default AnswerStatusIcon;
